import Routes from "./routes.vue";
import Times from "./times.vue";
import Dates from "./dates.vue";
import Warning from "./warning.vue";
import Addresses from "./addresses.vue";
import FilteredTrips from "./filteredTrips.vue";

export default {
  Routes,
  Times,
  Dates,
  Warning,
  Addresses,
  FilteredTrips
};